<template>
  <v-container>
    <v-card class="mx-auto mt-15">
      <template v-if="players.length > 0">
        <div
          style="display:inline-block"
          v-for="(data, index) in players"
          :key="index"
        >
          <WaitingPlayer :playerInfo="data" />
        </div>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import WaitingPlayer from "./WaitingPlayer.vue";
import refs from "./firebase/refs";

export default {
  name: "WaitingPlayers",
  props: {
    gameId: String,
  },
  components: {
    WaitingPlayer,
  },
  async created() {
    console.log("waitingplayers gameid", this.gameId);
    refs.players(this.gameId).on("value", (snapshot) => {
      var newPlayers = [];
      snapshot.forEach((player) => {
        newPlayers.push({
          player: player.val().player,
          image: player.val().image,
        });
        this.players = newPlayers;
      });
    });
  },
  data() {
    return {
      players: [],
    };
  },
};
</script>
